module.exports = __webpack_public_path__ + "media/1_new.384584d4.mp3";